<ng-container *ifScreenSize="screenType.Desktop">
  <div class="banner" role="banner">
    <h1>{{ 'challenges.page.title' | translate }}</h1>
  </div>
</ng-container>

<ng-container *ifScreenSize="screenType.Mobile">
  <fgb-barcode></fgb-barcode>
</ng-container>

<fgbcl-badge-achieved></fgbcl-badge-achieved>

<div class="mt-5">
  <fgbcl-scorecard-list-view
    [icon]="'chevron_right'"
    [showPlaceholder]="true"
    [isSponsorInBody]="false"
  ></fgbcl-scorecard-list-view>
</div>
